<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container">
    <div class="header"><img src="../assets/白底横板.png" alt="" /></div>
    <div class="content">
      <div class="tit-box">
        <span style="font-size: 30px; font-weight: 600">预约信息管理</span>
      </div>
      <div class="table-box">
        <div class="export-box">
          <a-button type="primary" danger @click="handleExport" class="export-btn">
            导出当页
          </a-button>
          <a-range-picker
            v-model:value="exportDateRange"
            format="YYYY-MM-DD"
            :placeholder="['开始日期', '结束日期']"
            :locale="zhCN.DatePicker"
            class="date-picker"
            allow-clear
          />
          <a-input
            v-model:value="maxExportCount"
            placeholder="最大导出条数,不填默认10000条"
            class="max-count-input"
          />
        </div>
        <a-table
          bordered="true"
          :columns="columns"
          :data-source="data"
          :scroll="{ x: 1500, y: 500 }"
          :pagination="pagination"
        >
          <template #bodyCell="{ column, record }">
            <!-- <template v-if="column.key === 'operation'"><a disabled
                                style="margin-right: 10px;">同意</a><a disabled>拒绝</a></template> -->
            <template v-if="column.key === 'state'">
              <span v-if="record.state === 0">审核中</span>
              <span v-if="record.state === 1">已同意</span>
              <span v-if="record.state === 2">已拒绝</span>
              <span v-if="record.state === 3">已签到</span>
            </template>
            <template v-if="column.key === 'contract'">
              <button
                @click="downLoadContract($event)"
                :data-id="record.id"
              >
                下载
              </button>
            </template>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script setup>
// eslint-disable-next-line no-unused-vars
import { ref, onMounted, reactive, nextTick } from "vue";
import { notification } from "ant-design-vue";
import axios from "axios";
import { RequestUrl } from "../api";
import { useRoute } from "vue-router";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import * as XLSX from "xlsx";
import zhCN from "ant-design-vue/es/locale/zh_CN";

// 设置 dayjs 为中文
dayjs.locale("zh-cn");

// 当前每页条数
const currentPageSize = ref(10);

const pagination = reactive({
  // 表格分页的配置
  current: 1,
  pageSize: 10,
  showSizeChanger: true, // 用于控制展示每页多少条的下拉
  showQuickJumper: true,
  total: 0,
  pageSizeOptions: ["10", "20", "50"],
  onChange: pageChange,
  onShowSizeChange: onPageSizeChange,
});

const route = useRoute();
const token = route.query.token;

// 导出相关数据
const exportDateRange = ref(null);
const maxExportCount = ref(null);

const columns = ref([
  {
    title: "提交时间",
    width: 100,
    dataIndex: "updateTime",
    key: "updateTime",
    fixed: "left",
  },
  {
    title: "来访人姓名",
    width: 100,
    dataIndex: "name",
    key: "name",
  },
  {
    title: "来访人证件号",
    dataIndex: "idNum",
    key: "idNum",
    width: 150,
  },
  {
    title: "来访人手机号",
    dataIndex: "phone",
    key: "phone",
    width: 150,
  },
  {
    title: "来访人工作单位",
    dataIndex: "workUnit",
    key: "workUnit",
    width: 150,
  },
  {
    title: "来访原因",
    dataIndex: "reasons",
    key: "reasons",
    width: 200,
  },
  {
    title: "接待人姓名",
    dataIndex: "receptionStaff",
    key: "receptionStaff",
    width: 150,
  },
  {
    title: "来访车辆号码",
    dataIndex: "carNum",
    key: "carNum",
    width: 150,
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
    width: 150,
  },
  {
    title: "接待人部门",
    dataIndex: "receptionDep",
    key: "receptionDep",
    width: 200,
  },
  {
    title: "下载安全协议",
    key: "contract",
    width: 200,
  },
  {
    title: "操作/状态",
    key: "state",
    fixed: "right",
    width: 100,
  },
]); //表头
const data = ref([]); //表格数据

function pageChange(nextPage, pageSize) {
  console.log(nextPage, pageSize);

  getData(nextPage, pageSize || currentPageSize.value).then((result) => {
    if (result) {
      const { list, res } = result;
      data.value = list;
      pagination.current = nextPage;
      pagination.total = res.content.page.totalPages * res.content.page.rows;
      pagination.pageSize = res.content.page.rows;
      console.log(list);
    }
  });
}

function onPageSizeChange(current, size) {
  console.log("每页条数变化:", current, size);
  currentPageSize.value = size;
  pagination.pageSize = size;
  pagination.current = 1; // 重置到第一页
  getData(1, size).then((result) => {
    if (result) {
      const { list, res } = result;
      data.value = list;
      pagination.current = 1;
      pagination.total = res.content.page.totalPages * res.content.page.rows;
      pagination.pageSize = res.content.page.rows;
    }
  });
}

function getData(page, pageSize = 10) {
  return axios({
    method: "get",
    url: `${RequestUrl}visitorInfo/findByPageAndCondition`,
    params: {
      rows: pageSize, // 每页行数
      page: page, // 当前页码
      order: "insertTime",
      sort: "desc",
    },
    headers: {
      token: token,
    },
  })
    .then((res) => {
      if (res.data.stateCode === 1000) {
        console.log(res.data.content.list);
        const newArr = res.data.content.list.map((item) => {
          const { listNum, ...rest } = item; // 提取 listNum 并将其余的键值存储在 rest 中
          return { key: listNum, ...rest }; // 返回新的对象，key 为 listNum，其他键值不变
        });
        return { list: newArr, res: res.data };
      } else {
        notification["error"]({
          message: "错误--" + res.data.stateCode,
          description: res.data.content,
        });
        return null;
      }
    })
    .catch((error) => {
      notification["error"]({
        message: "出错了",
        description: error.message || error,
      });
      return null;
    });
}
function downLoadContract(event) {
  axios({
    method: "get",
    url: `${RequestUrl}visitorInfo/makePaper`,
    params: {
      id: event.target.getAttribute("data-id"),
    },
    headers: {
      token: token,
    },
    responseType: 'blob', // 设置响应类型为blob
  })
    .then((res) => {
      if (res.status === 200) {
        // 创建Blob对象
        const blob = new Blob([res.data], { type: 'application/pdf' });
        // 创建下载链接
        const downloadUrl = window.URL.createObjectURL(blob);
        // 创建a标签并点击触发下载
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `安全协议_${event.target.getAttribute("data-id")}.pdf`; // 设置下载文件名
        document.body.appendChild(link);
        link.click();
        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }
    })
    .catch((error) => {
      notification["error"]({
        message: "出错了",
        description: error.message || error,
      });
      return null;
    });
}

// 获取状态文本
function getStateText(state) {
  const stateMap = {
    0: "审核中",
    1: "已同意",
    2: "已拒绝",
    3: "已签到"
  };
  return stateMap[state] || "未知";
}

// 统一的导出处理函数
function handleExport() {
  // 如果选择了日期范围，则按日期范围导出
  if (exportDateRange.value && exportDateRange.value.length === 2) {
    exportByDateRange();
  } else {
    // 否则导出当页
    exportCurrentPage();
  }
}

// 导出当页数据
function exportCurrentPage() {
  if (!data.value || data.value.length === 0) {
    notification["warning"]({
      message: "提示",
      description: "当前页面没有数据可导出",
    });
    return;
  }

  // 准备导出数据
  const exportData = data.value.map((item) => ({
    提交时间: item.updateTime || "",
    来访人姓名: item.name || "",
    来访人证件号: item.idNum || "",
    来访人手机号: item.phone || "",
    来访人工作单位: item.workUnit || "",
    来访原因: item.reasons || "",
    接待人姓名: item.receptionStaff || "",
    来访车辆号码: item.carNum || "",
    备注: item.remark || "",
    接待人部门: item.receptionDep || "",
    状态: getStateText(item.state),
  }));

  // 创建工作簿
  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "预约信息");

  // 生成文件名
  const fileName = `预约信息_${dayjs().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;

  // 导出文件
  XLSX.writeFile(wb, fileName);

  notification["success"]({
    message: "导出成功",
    description: `已导出 ${exportData.length} 条数据`,
  });
}

// 按日期范围和最大条数导出
async function exportByDateRange() {
  if (!exportDateRange.value || exportDateRange.value.length !== 2) {
    notification["warning"]({
      message: "提示",
      description: "请选择导出日期区间",
    });
    return;
  }

  const startDate = dayjs(exportDateRange.value[0]).format("YYYY-MM-DD");
  const endDate = dayjs(exportDateRange.value[1]).format("YYYY-MM-DD");
  const maxCount = maxExportCount.value ? parseInt(maxExportCount.value) || 10000 : 10000;

  notification["info"]({
    message: "正在导出",
    description: "数据量较大，请稍候...",
    duration: 2,
  });

  try {
    // 获取所有符合条件的数据
    let allData = [];
    let currentPage = 1;
    let hasMore = true;

    while (hasMore && allData.length < maxCount) {
      const result = await getDataForExport(currentPage, startDate, endDate);
      
      if (result && result.list && result.list.length > 0) {
        allData = allData.concat(result.list);
        currentPage++;
        
        // 如果返回的数据少于每页数量，说明没有更多数据了
        if (result.list.length < 10) {
          hasMore = false;
        }
        
        // 如果已达到最大条数，停止获取
        if (allData.length >= maxCount) {
          allData = allData.slice(0, maxCount);
          hasMore = false;
        }
      } else {
        hasMore = false;
      }
    }

    if (allData.length === 0) {
      notification["warning"]({
        message: "提示",
        description: "所选日期范围内没有数据可导出",
      });
      return;
    }

    // 准备导出数据
    const exportData = allData.map((item) => ({
      提交时间: item.updateTime || "",
      来访人姓名: item.name || "",
      来访人证件号: item.idNum || "",
      来访人手机号: item.phone || "",
      来访人工作单位: item.workUnit || "",
      来访原因: item.reasons || "",
      接待人姓名: item.receptionStaff || "",
      来访车辆号码: item.carNum || "",
      备注: item.remark || "",
      接待人部门: item.receptionDep || "",
      状态: getStateText(item.state),
    }));

    // 创建工作簿
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "预约信息");

    // 生成文件名
    const fileName = `预约信息_${startDate}_${endDate}_${dayjs().format("HH-mm-ss")}.xlsx`;

    // 导出文件
    XLSX.writeFile(wb, fileName);

    notification["success"]({
      message: "导出成功",
      description: `已导出 ${exportData.length} 条数据`,
    });
  } catch (error) {
    notification["error"]({
      message: "导出失败",
      description: error.message || error,
    });
  }
}

// 获取导出数据（支持日期范围）
function getDataForExport(page, startDate, endDate) {
  return axios({
    method: "get",
    url: `${RequestUrl}visitorInfo/findByPageAndCondition`,
    params: {
      rows: 10,
      page: page,
      order: "insertTime",
      sort: "desc",
      startDate: startDate,
      endDate: endDate,
    },
    headers: {
      token: token,
    },
  })
    .then((res) => {
      if (res.data.stateCode === 1000) {
        const newArr = res.data.content.list.map((item) => {
          const { listNum, ...rest } = item;
          return { key: listNum, ...rest };
        });
        return { list: newArr, res: res.data };
      } else {
        return null;
      }
    })
    .catch((error) => {
      console.error("获取数据失败:", error);
      return null;
    });
}
onMounted(async () => {
  getData(1, currentPageSize.value).then((result) => {
    if (result) {
      const { list, res } = result;
      console.log();

      data.value = list;
      pagination.total = res.content.page.totalPages * res.content.page.rows;
      pagination.pageSize = res.content.page.rows;
      currentPageSize.value = res.content.page.rows;

      console.log("data", pagination); // 在数据加载完成后打印
    }
  });
});
</script>
<style scoped>
html,
body {
  overflow: hidden;
}

.container {
  background-color: #ebebeb;
}

.content {
  border-radius: 8px;
  margin: 40px;
  padding: 20px;
}

.header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 70px;
  background-image: url("../assets/header-bg.png");
}

img {
  width: 20%;
  height: 100%;
  object-fit: cover;
}

.tit-box {
  width: 100%;
  height: 80px;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin-top: 20px;
}

.export-box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.export-btn {
  background-color: rgb(158, 46, 46);
  border-color: rgb(158, 46, 46);
  height: 32px;
}

.export-btn:hover {
  background-color: rgb(180, 60, 60);
  border-color: rgb(180, 60, 60);
}

.date-picker {
  width: 300px;
}

.max-count-input {
  width: 280px;
}

.table-box {
  padding: 40px;
  background-color: white;
  border-radius: 8px;
}

#components-table-demo-summary tfoot th,
#components-table-demo-summary tfoot td {
  background: #fafafa;
  padding: 0 !important;
}

[data-theme="dark"] #components-table-demo-summary tfoot th,
[data-theme="dark"] #components-table-demo-summary tfoot td {
  background: #1d1d1d;
}
button {
  border: none;
  background-color: rgb(158, 46, 46);
  color: white;
}
</style>